import React from "react";

const UserDashboardProgressTable = ({ game }) => {
  const time = 300 - game?.remainingTime;
  const present = Math.ceil((time / 300) * 100, 2);

  // for match gavor 10 minute
  const matchTime = 600 - game?.remainingTime;
  const matchPresent = Math.ceil((matchTime / 600) * 100, 2);

  console.log(game)


  // ..
  return (
    <tr className="border-b border-slate-200">
      <td className="h-16 px-6  transition duration-300 border-slate-200 stroke-black text-black ">
        {game?.gameName}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 whitespace-nowrap">
        {game?.date} , {game?.time}
      </td>
      <td className="h-16 px-6 text-sm transition duration-300 border-slate-200 stroke-slate-500 text-slate-500 ">
        <div class="h-2 w-full bg-neutral-200  rounded-full">
          <div
            class="h-2 bg-secondary rounded-full"
            style={{
              width: `${game?.gameName ==="Match Gabor Monocular"?matchPresent:present}%` }}
          ></div>
        </div>
      </td>
    </tr>
  );
};

export default UserDashboardProgressTable;
